import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { notification } from 'antd';
import { I18n } from '@aws-amplify/core';
import Api from '@/services/api';
import { QUERY_KEYS } from '@/utils/query-keys';
import { CreateReportDTO, CreateReportResponse } from '@/views/CreateReport/context/types';

type CreateKimMhoError = AxiosError<any>;

async function createReport(parameters: CreateReportDTO) {
	const { data } = await Api.post('/ergonomic-tool/kim-mho', parameters);
	return data;
}

export const useCreateKimMho = () => {
	const queryClient = useQueryClient();
	return useMutation<CreateReportResponse, CreateKimMhoError, CreateReportDTO>((payload) => createReport(payload), {
		onSuccess: async () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_KIM_MHO_REPORT]);
		},
		onError: (err) => {
			const title = 'Oops! Something happened.';
			const message = err.response?.data?.message ?? 'Failed to create information';
			notification.error({
				message: I18n.get(title),
				description: I18n.get(message)
			});
		}
	});
};
